import React from "react";
import { Switch as AntdSwitch } from "antd";

const CustomSwitch = ({
  label,
  subheader,
  checked,
  onChange,
  labelPosition = "pre",
  labelClass = "text-default text-sm",
  subheaderClass = "text-sm text-secondary font-normal",
  size = "small",
  handleChange,
  disabled = false,
  loading = false,
}) => {
  // Use handleChange if provided, otherwise use onChange
  const switchChangeHandler = handleChange || onChange;

  return (
    <div className="flex items-start mb-1">
      {labelPosition === "pre" && (
        <>
          <div className="flex flex-col">
            <span className={labelClass}>{label}</span>
            {subheader && <span className={subheaderClass}>{subheader}</span>}
          </div>
          <div className={`${labelClass ? "ml-4" : ""}`}>
            <AntdSwitch
              size={size}
              checked={checked}
              onChange={switchChangeHandler}
              disabled={disabled}
              loading={loading}
            />
          </div>
        </>
      )}
      {labelPosition === "post" && (
        <>
          <AntdSwitch
            size={size}
            checked={checked}
            onChange={switchChangeHandler}
            disabled={disabled}
            loading={loading}
          />
          <div className="ml-4 flex flex-col">
            <span className={labelClass}>{label}</span>
            {subheader && <span className={subheaderClass}>{subheader}</span>}
          </div>
        </>
      )}
    </div>
  );
};

export default CustomSwitch;
